import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=593f5077&scoped=true&"
import script from "./ProfileInfo.vue?vue&type=script&lang=js&"
export * from "./ProfileInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInfo.vue?vue&type=style&index=0&id=593f5077&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593f5077",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('593f5077', component.options)
    } else {
      api.reload('593f5077', component.options)
    }
    module.hot.accept("./ProfileInfo.vue?vue&type=template&id=593f5077&scoped=true&", function () {
      api.rerender('593f5077', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/info/ProfileInfo.vue"
export default component.exports